var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-top",on:{"click":function($event){return _vm.scrollTo({ to: 0 })}}},[_c('i',{staticClass:"fas fa-angle-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }